const DIMENSION = 16;

function key(x, y) {
  return `${x},${y}`;
}

function setWall(map, x, y, side) {
  if (!map[key(x, y)]) map[key(x, y)] = { top: false, right: false, bottom: false, left: false };
  map[key(x, y)][side] = true;
}

// `missions` carry their own wall sides; `extraWalls` are the free-standing bars
// a quadrant contributes on its own — the notches that used to be hardcoded here.
// Both arrive in absolute board coordinates, already rotated, from assembleBoard.
function buildWallMap(missions, extraWalls = []) {
  const map = {};

  for (let x = 0; x < DIMENSION; x++) {
    setWall(map, x, 0, 'top');
    setWall(map, x, DIMENSION - 1, 'bottom');
  }
  for (let y = 0; y < DIMENSION; y++) {
    setWall(map, 0, y, 'left');
    setWall(map, DIMENSION - 1, y, 'right');
  }

  setWall(map, 7, 7, 'top');   setWall(map, 8, 7, 'top');
  setWall(map, 7, 7, 'left');  setWall(map, 7, 8, 'left');
  setWall(map, 7, 8, 'bottom'); setWall(map, 8, 8, 'bottom');
  setWall(map, 8, 7, 'right'); setWall(map, 8, 8, 'right');

  for (const wall of extraWalls) setWall(map, wall.x, wall.y, wall.side);
  for (const mission of missions) {
    for (const side of mission.walls) setWall(map, mission.x, mission.y, side);
  }

  return map;
}

export { buildWallMap, DIMENSION };
